var _Defs, _Use, _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, Symbol as _Symbol, Circle, Path, Use, LinearGradient, Stop } from "react-native-svg";
function SvgCold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(_Symbol, {
    id: "cold_svg__c",
    viewBox: "0 0 72 168"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 36,
    cy: 132,
    r: 36,
    fill: "#2885c7"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M36 12v120",
    fill: "none",
    stroke: "#2885c7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "cold_svg__d",
    viewBox: "0 0 118 278"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M115 218.16C115 249.55 89.93 275 59 275S3 249.55 3 218.16a57 57 0 0124-46.6V35.48a32 32 0 1164 0v136.08a57 57 0 0124 46.6zM63 83h28M63 51h28m-28 64h28",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    fill: "url(#cold_svg__a)",
    stroke: "url(#cold_svg__b)"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "cold_svg__e",
    viewBox: "0 0 118 278"
  }, /*#__PURE__*/React.createElement(Use, {
    width: 72,
    height: 168,
    transform: "translate(23 87)",
    xlinkHref: "#cold_svg__c"
  }), /*#__PURE__*/React.createElement(Use, {
    width: 118,
    height: 278,
    xlinkHref: "#cold_svg__d"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cold_svg__a",
    x1: -7.17,
    y1: 36.31,
    x2: 116.44,
    y2: 250.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#515a69",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#6b7280",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#384354",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cold_svg__b",
    x1: -8.67,
    y1: 33.71,
    x2: 117.94,
    y2: 253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#959aa2"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 118,
    height: 278,
    transform: "translate(197 117)",
    xlinkHref: "#cold_svg__e"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M372.5 271a4.59 4.59 0 00-3.18 1.26L350 290.66l-19.32-18.4a4.64 4.64 0 00-6.36 0 4.14 4.14 0 000 6.06l22.5 21.42a4.64 4.64 0 006.36 0l22.5-21.42a4.14 4.14 0 000-6.06 4.59 4.59 0 00-3.18-1.26z",
    fill: "#2a81bf"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M372.5 244a4.59 4.59 0 00-3.18 1.26L350 263.66l-19.32-18.4a4.64 4.64 0 00-6.36 0 4.14 4.14 0 000 6.06l22.5 21.42a4.64 4.64 0 006.36 0l22.5-21.42a4.14 4.14 0 000-6.06 4.59 4.59 0 00-3.18-1.26z",
    fill: "#2a81bf"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M372.5 217a4.59 4.59 0 00-3.18 1.26L350 236.66l-19.32-18.4a4.64 4.64 0 00-6.36 0 4.14 4.14 0 000 6.06l22.5 21.42a4.64 4.64 0 006.36 0l22.5-21.42a4.14 4.14 0 000-6.06 4.59 4.59 0 00-3.18-1.26z",
    fill: "#2a81bf"
  })));
}
export default SvgCold;